import * as React from 'react';
import {BatchDialogStore} from './batch-dialog-store';
import {SvgWrapper} from '../../components/svg-wrapper';
import {TooltipComponent} from '../../components/tooltip-component';

export class BatchAddNewDepositLink extends React.Component<{store: BatchDialogStore, canAccessCheckScanningPortal: boolean}> {
	render() {
		const { openDialogOrCheckScanningPortal, isCheckScanningReadOnly } = this.props.store;
		const { canAccessCheckScanningPortal } = this.props;
		const isDisabled = isCheckScanningReadOnly || !canAccessCheckScanningPortal;

		let tooltipMessage = '';
		if (isCheckScanningReadOnly) {
			tooltipMessage = "Check deposit is read-only for your organization. Please contact our customer service for assistance.";
		} else if (!canAccessCheckScanningPortal) {
			tooltipMessage = "You don't have access to the check scanning portal. Reach out to your organization admin to request access.";
		}

		return(
			<span>
				<button type="button" className="btn btn-link btn-sm"
					disabled={isDisabled}
					onClick={openDialogOrCheckScanningPortal}>
					{isDisabled ? (
						<TooltipComponent
							className="tooltip-info"
							message={tooltipMessage}
							placement="top"
						/>
					) : (
						<SvgWrapper svg="icon-follow-link" className="icon" />
					)}
					Open check scanning portal
				</button>
			</span>
		);
	}
}
